import axios from "axios";
import API_ROUTE from "./utils/apiRoute";

// Ensure we don't add the interceptor multiple times (HMR/dev)
let interceptorId = null;

export function setupAxiosAuth(getToken) {
  if (interceptorId !== null) return;

  interceptorId = axios.interceptors.request.use(
    async (config) => {
      const url = config.url || "";
      const isApiCall =
        url.startsWith(API_ROUTE) ||
        (!!config.baseURL && config.baseURL === API_ROUTE);

      if (isApiCall && typeof getToken === "function") {
        const token = await getToken(); // ✅ AuthProvider controls refresh
        if (token) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${token}`;
        }
      }

      // Keep your existing cookie behavior if still needed
      config.withCredentials = true;

      return config;
    },
    (error) => Promise.reject(error)
  );
}

// Optional: allow cleanup (nice for tests / HMR)
export function ejectAxiosAuth() {
  if (interceptorId === null) return;
  axios.interceptors.request.eject(interceptorId);
  interceptorId = null;
}
